<template>
    <router-link v-if="product.href" class="col-xs-10 col-lg-5 col-sm-5 " :to="product.href">
        <div class="box">
            <div class="box--overlay"></div>
            <img :src="product.src"/>
            <h3>{{ product.titles.fr.join(' / ') }}<br/><span>{{ product.titles.en.join(' / ') }}</span></h3>
        </div>
    </router-link>
    <div v-else class="box col-xs-10 col-lg-5 col-sm-5">
        <div class="box--overlay"></div><img :src="product.src"/>
        <h3>{{ product.titles.fr.join(', ') }} / <span>{{ product.titles.en.join(', ') }}</span></h3>
        <div class="box--societies">
            <div class="box--society col-xs-4" v-for="(manufacturer, index) in product.manufacturers" :key="index">
                <a class="col-xs-12" :href="manufacturer.href">{{ manufacturer.name }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SubProductBox",
        props: {
            product: {type: Object, required: true}
        }
    }
</script>

<style lang="scss" scoped>
    .box:hover {
        .box--overlay {
            background: transparentize(#000000, 0.4);
        }
    }
    .box--societies:last-child {
        /* -or- li:only-child { */
        justify-content: center;
            div {
                flex: 3;
            }
    }
</style>